var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcReduce(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1513 4.08121L13.5 1.42996V8.49996H20.57L17.9188 5.84871L21.8838 1.88371L20.1163 0.116211L16.1513 4.08121ZM1.88377 0.116211L0.116272 1.88371L4.08127 5.84871L1.43002 8.49996H8.50002V1.42996L5.84877 4.08121L1.88377 0.116211ZM20.57 13.5H13.5V20.57L16.1513 17.9187L20.1163 21.8837L21.8838 20.1162L17.9188 16.1512L20.57 13.5ZM4.08127 16.1512L0.116272 20.1162L1.88377 21.8837L5.84877 17.9187L8.50002 20.57V13.5H1.43002L4.08127 16.1512Z",
    fill: "#F8F8F8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcReduce);
export default __webpack_public_path__ + "static/media/ic_reduce.0cf5023ce215f6623c624a4e2b51f376.svg";
export { ForwardRef as ReactComponent };